export const scrollToFormHandler = (elementId: string, headerHeight: number = 90): void => {
  const block = document.getElementById(elementId);
  if (!block) return;

  const blockPosition = block.getBoundingClientRect().top + window.scrollY - headerHeight;
  window.scrollTo({
    top: blockPosition,
    behavior: 'smooth',
  });
};
